import gql from "graphql-tag";

// Staff Fragment
const RoomStaffProps = gql`
    fragment RoomStaffProps on Staff {
        id
        admin
        image
        department {
            id
            name
        }
        designation {
            id
            name
        }
        type {
            id
            name
        }
        surname
        first_name
        middle_name
        email
    }
`;

// RommSearch Fragment
const SearchProps = gql`
    fragment SearchProps on RoomSearch {
        id
        startTime
        searchDate
        endTime
        postToSearch
        priorToSearch
        present
        consent
        comment
        author {
            ...RoomStaffProps
        }
        created_at
        reason
        members {
            ...RoomStaffProps
        }
    }
    ${RoomStaffProps}
`;

const LIST = gql`
    query GetRoomSearch($id: ID!) {
        GetRoomSearches(id: $id) {
            docs {
                ...SearchProps
            }
        }
        GetStaffList(page: 1, limit: 2000) {
            docs {
                ...RoomStaffProps
            }
        }
    }
    ${SearchProps}
    ${RoomStaffProps}
`;

//  Start new Search
const START_SEARCH = gql`
    mutation StartSearch($admission: ID!, $model: RoomSearchInput!) {
        NewRoomSearch(id: $admission, model: $model) {
            message
            doc {
                ...SearchProps
            }
        }
    }
    ${SearchProps}
`;
export { LIST, START_SEARCH };
